var map = function () {

  var publicMethods = {};

  var elements = document.querySelectorAll('.js-map');

  publicMethods.init = function() {

    if (!elements.length) return;
    
    for (var i = 0; i < elements.length; i++) {
			
			(function (i) {
				
				setup(elements[i]);

			})(i);
		
		}

  };

  function setup(element) {

		var timeout = null;
		var lat = parseFloat(element.getAttribute('data-latitude'));
		var lng = parseFloat(element.getAttribute('data-longitude'));
		var zoom = parseInt(element.getAttribute('data-zoom'), 10);
		var latLng = {
			lat: lat,
			lng: lng
		};

		var _map = new google.maps.Map(element, {
			center: latLng,
			zoom: zoom,
			scrollwheel: false,
			streetViewControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		var marker = new google.maps.Marker({
			position: latLng,
			map: _map,
			clickable: false
		});

		window.addEventListener('resize', function() {
			if (timeout != null) clearTimeout(timeout);
			timeout = setTimeout(function () {
				_map.setCenter(latLng);
				timeout = null;
			}, 50);
		});

  };

  return publicMethods;

}();

window.addEventListener('load', function() { map.init(); });
